<script lang="ts">
    import { tick } from 'svelte'

    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import { gettext as _ } from 'hydria/services/gettext'
    import { DateTime, toLuxon } from 'hydria/utils/time'

    import { d3, nv, nvReady } from 'wdom/utils/nvd'

    import type { IEntry } from './nsd_defs'

    interface Props {
        loading: boolean
        entries: IEntry[] | undefined | null
    }

    let { loading, entries }: Props = $props()

    let chart: any
    let chartSvg: any

    const gdata = [{ ikey: 'apdex_score', key: 'Apdex score', color: '#1f77b4', values: [] as any[] }]

    function createChart() {
        if (!entries) {
            return
        }
        for (const gd of gdata) {
            gd.values = []
        }

        for (const e of entries) {
            for (const gd of gdata) {
                gd.values.push({
                    x: e.hour,
                    y: e[gd.ikey],
                })
            }
        }

        tick().then(() => {
            nv.addGraph(() => {
                chart = nv.models.lineChart().id(
                    Math.random()
                        .toString(36)
                        .slice(2, 2 + 15),
                )
                chart.xAxis
                    // .rotateLabels(50)
                    .showMaxMin(false)
                    .axisLabel('Day::Hour')
                    .tickFormat((d: DateTime) => {
                        return toLuxon(d).toFormat('dd::HH')
                    })
                chart.yAxis.showMaxMin(true).axisLabel('Apdex Score')
                // .tickFormat((d: number) => {
                //     return d / 1000
                // })
                chart.margin({
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 60,
                })

                chartSvg = d3.select('#chart-nsd-server-apdex')
                chartSvg.datum(gdata).call(chart)
            })
        })
    }

    let charted = false
    $effect(() => {
        if (!charted && $nvReady && loading == false && entries != null) {
            charted = true
            createChart()
        }
    })
</script>

<style>
    #chart-nsd-server-apdex {
        height: 150px;
        width: 100%;
    }
</style>

<div class="card">
    <div class="card-title text-primary">Apdex</div>
    {#if loading !== false}
        <div class="card-body">
            <LoadingPattern pattern={['x', 'x', 'x', 'x']} />
        </div>
    {:else}
        <div class="card-body">
            <svg id="chart-nsd-server-apdex" class="nvd3-svg" />
        </div>
    {/if}
</div>
